// extracted by mini-css-extract-plugin
module.exports = {"container":"_373a3719ba--container--G3xMC"};